type CustomerAuthSwitchLinkProps = {
  textPrefix: string
  linkLabel: string
  href: string
}

export const CustomerAuthSwitchLink = ({
  textPrefix,
  linkLabel,
  href,
}: CustomerAuthSwitchLinkProps) => (
  <div className="mt-4 border-t border-(--color-border-subtle) pt-3 text-sm text-(--color-text-secondary)">
    <p className="text-center">
      {textPrefix}{' '}
      <a
        href={href}
        className="font-semibold text-(--color-text-primary) underline decoration-[color-mix(in_srgb,var(--color-focus-ring)_40%,transparent)] underline-offset-4 hover:text-(--color-focus-ring)"
      >
        {linkLabel}
      </a>
    </p>
  </div>
)
